/* global PhotoSwipe PhotoSwipeUI_Default */
window.initPhotoSwipeFromDOM = function(gallerySelector, itemSelector) {

  var parseThumbnailElements = function(el) {
    var $thumbElements = $(el).find(itemSelector),
      items = [],
      $el,
      size,
      item;

    $thumbElements.each(function(){
      $el = $(this);
      size = $el.data('size').split('x');
      // create slide object
      item = {
        src: $el.attr('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10),
        title: $el.attr('title'),
        //msrc: $el.find('img').attr('src')
      };
      item.el = $el[0]; // save link to element for getThumbBoundsFn
      items.push(item);
    });

    return items;
  };

  // triggers when user clicks on thumbnail
  var onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;

    var eTarget = e.target || e.srcElement;
    var index = 0;
    var clickedGallery = $(eTarget).closest(gallerySelector)[0];
    var clickedItem = $(eTarget).closest(itemSelector)[0];

    if(!clickedItem) {
      return;
    }

    $(clickedGallery).find(itemSelector).each(function(i){
      if (this == clickedItem) {
        index = i;
      }
    });

    if(index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  var photoswipeParseHash = function() {
    var hash = window.location.hash.substring(1),
      params = {};

    if(hash.length < 5) {
      return params;
    }

    var vars = hash.split('&');
    for (var i = 0; i < vars.length; i++) {
      if(!vars[i]) {
        continue;
      }
      var pair = vars[i].split('=');
      if(pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if(params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  var openPhotoSwipe = function(index, galleryElement) {
    var pswpElement = document.querySelectorAll('.pswp')[0],
      gallery,
      options,
      items;

    items = parseThumbnailElements(galleryElement);

    // define options (if needed)
    options = {
      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      shareEl: false,
      fullscreenEl: false,
      history: true,
      zoomEl: false,
      showHideOpacity:true,
      showAnimationDuration:0,
      hideAnimationDuration:0,
      bgOpacity:1,
      tapToClose: true,
      closeOnScroll: false,
      loop: false,
      timeToIdle:0,
      timeToIdleOutside:0,
      maxSpreadZoom:1.33,

      getDoubleTapZoom: function(isMouseClick, item) {
        if(isMouseClick) {
          return Math.min(item.initialZoomLevel + 0.2, 1);
        } else {
          return Math.min(item.initialZoomLevel + 0.2, 1);
        }
      },

      getThumbBoundsFn: false,
      //getThumbBoundsFn: function(index) {
        //// See Options -> getThumbBoundsFn section of documentation for more info
        //var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
          //pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
          //rect = thumbnail.getBoundingClientRect();
        //return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
      //}
    };

    // PhotoSwipe opened from URL
    options.index = parseInt(index, 10);

    // exit if index not found
    if( isNaN(options.index) ) {
      return;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };

  // loop through all gallery elements and bind events
  var galleryElements = document.querySelectorAll(gallerySelector);

  for(var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i+1);
    $(document).off('click.photoswipe').on('click.photoswipe', itemSelector, onThumbnailsClick);
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  var openPhotoSwipeFromHash = function() {
    var hashData = photoswipeParseHash();
    if(hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.pid, galleryElements[hashData.gid-1], true, true );
    }
  };

  openPhotoSwipeFromHash();
};



